module.exports = __webpack_public_path__ + "static/je-6ab0861417269eb87fc430130668527d.svg";